export var IdCoopMemberSortBy;
(function (IdCoopMemberSortBy) {
    IdCoopMemberSortBy["Rank"] = "Rank";
    IdCoopMemberSortBy["Name"] = "Name";
    IdCoopMemberSortBy["Xp"] = "Xp";
    IdCoopMemberSortBy["Funds"] = "Funds";
})(IdCoopMemberSortBy || (IdCoopMemberSortBy = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/IdCoopMemberSortBy.ts
// module id = 2614
// module chunks = 3